
const facilities = [
  {
    category: '公共區設施與服務',
    items: [
      { icon: 'ri-community-line', name: '交誼廳' },
      { icon: 'ri-wifi-line', name: '公共區域 WIFI' },
      { icon: 'ri-plant-line', name: '花園' },
      { icon: 'ri-water-flash-line', name: '沖沙處' },
      { icon: 'ri-luggage-deposit-line', name: '行李寄放' }
    ]
  },
  {
    category: '餐飲設施',
    items: [
      { icon: 'ri-restaurant-line', name: '公用廚房' },
      { icon: 'ri-service-line', name: '代客訂餐服務' },
      { icon: 'ri-table-line', name: '公用用餐區' },
      { icon: 'ri-fire-line', name: '爐台' },
      { icon: 'ri-tree-line', name: '戶外用餐區' },
      { icon: 'ri-drop-line', name: '飲水機' },
      { icon: 'ri-cup-line', name: '杯子' }
    ]
  },
  {
    category: '安全設施',
    items: [
      { icon: 'ri-camera-line', name: '監視器' },
      { icon: 'ri-first-aid-kit-line', name: '醫藥箱' },
      { icon: 'ri-fire-extinguisher-line', name: '滅火器' }
    ]
  },
  {
    category: '服務語言',
    items: [
      { icon: 'ri-translate-2', name: '中文' },
      { icon: 'ri-english-input', name: '英文' },
      { icon: 'ri-chat-3-line', name: '閩南語' }
    ]
  },
  {
    category: '須額外購買，現場付費',
    items: [
      { icon: 'ri-fire-fill', name: 'BBQ 燒烤設備', highlight: true },
      { icon: 'ri-building-line', name: '提供場地租借', highlight: true },
      { icon: 'ri-headphone-line', name: '耳塞', highlight: true },
      { icon: 'ri-music-2-line', name: '卡拉OK', highlight: true }
    ]
  }
];

export default function Facilities() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">旅宿設施</h2>
          <p className="text-xl text-gray-600">完善的設施與服務，讓您住得舒適安心</p>
        </div>

        <div className="space-y-12">
          {facilities.map((section, idx) => (
            <div key={idx} className="bg-gray-50 rounded-2xl p-8">
              <h3 className={`text-2xl font-bold mb-6 ${section.items[0]?.highlight ? 'text-orange-600' : 'text-gray-900'}`}>
                {section.category}
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                {section.items.map((item, itemIdx) => (
                  <div 
                    key={itemIdx} 
                    className={`flex items-center gap-3 p-4 rounded-lg transition-all duration-300 ${
                      item.highlight 
                        ? 'bg-orange-50 hover:bg-orange-100' 
                        : 'bg-white hover:bg-gray-100'
                    }`}
                  >
                    <div className={`w-10 h-10 flex items-center justify-center rounded-full ${
                      item.highlight ? 'bg-orange-100' : 'bg-teal-100'
                    }`}>
                      <i className={`${item.icon} text-xl ${
                        item.highlight ? 'text-orange-600' : 'text-teal-600'
                      }`}></i>
                    </div>
                    <span className={`text-sm font-medium ${
                      item.highlight ? 'text-orange-700' : 'text-gray-700'
                    }`}>
                      {item.name}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
